import { Component, OnDestroy, OnInit, EventEmitter, Input, Output,
  ViewContainerRef, OnChanges, NgZone, ViewChild, ElementRef, TemplateRef, ViewEncapsulation } from '@angular/core';
import { DemoService } from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import { Routes, RouterModule, Router } from '@angular/router';

// import { CurrentsDataSourceComponent } from './../../../views/appviews/currents-data-source/currents-data-source.component';
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';



// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import { Observable, Subject,  map } from 'rxjs';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { MysqlService } from './../../../services/mysql.service';
import { BsModalService } from 'ngx-bootstrap';

import { JobSubject } from './../../../shared/models/jobSubject.model';
import { NgForm } from '@angular/forms';

// :: New data picker sync fusion
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CalendarComponent, DateTimePickerComponent } from '@syncfusion/ej2-angular-calendars';
import {setCulture} from '@syncfusion/ej2-base';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { TabsetComponent, TabsModule } from 'ngx-bootstrap';
import { DataUtil } from '@syncfusion/ej2-data';
import { ToolbarService, HtmlEditorService, CountService, ImageService, LinkService, PasteCleanupService } from '@syncfusion/ej2-angular-richtexteditor';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard
import { HotToastService } from '@ngneat/hot-toast';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentEditorComponent, DocumentEditorContainerComponent } from '@syncfusion/ej2-angular-documenteditor';


setCulture('au');
// :: Define and declare google as Var
// :: also remember to place mapping api javascipt in index.html of this app.
// ::@ https://github.com/dhormale/google-places-autocomplete
declare var google: any;
@Component({
  selector: 'app-quicklinks-menus-widget',
  templateUrl: './quicklinks-menus-widget.component.html',
  styleUrls: ['./quicklinks-menus-widget.component.scss']
})
export class QuicklinksMenusWidgetComponent implements OnInit {


// setup as observable?
  // @Input() item_id?: Observable<any[]>; // impliments on changes.
  @Input() item_id?; // impliments on changes.
  @Input() item_data?: any; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data?= 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id?= '5'; // default to agent just in case
  @Input() item_brand_type_id?= '';
  @Input() show_buttons?= 'no'; // yes | no
  @Input() widget_title?= '';
  @Input() widget_size?= 'side'; // side | abstract | full | admincard
  modalRef: any;
  // [subject_automation_model]="model"
  @Input() subject_automation_model?; // impliments on changes.
  @Input() quick_link_type?; // impliments on changes. subject | job
  @Input() quick_link_brand_type_id?; // impliments on changes. subject | job
  DialogObj: any;



  constructor(private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute,
    vcr: ViewContainerRef, private router: Router, 
    public HttpClient: HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    public zone: NgZone, // added for google address API component
    postcodeElement: ElementRef,
    private clipboard: Clipboard, // ciipboard
    public toastr: HotToastService,
    private sanitizer: DomSanitizer,) { }

  ngOnInit(): void {
  }


  // start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // this.modalRef = this.modalService.show(template);
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}



// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div

// :: Reloads the email list
// this.getSubjectContactEmails(this.subject_id);
// this.getSubjectContactNumbers(this.subject_id);
// this.getJobSubjectDocumentsBySubjectID(this.subject_id);

};




    // custom dialog

    public onOpenDialogNewStage = function(event: any, filename, model): void {
      this.DialogObj = DialogUtility.confirm({
      title: 'Create New Subject Stage',
      content: 'Create a new subject stage from this existing subject details',
      okButton: { text: 'Generate New Subject', click: this.okNewStageClick.bind(this, filename, model) },
      cancelButton: {  text: 'Cancel', click: this.cancelNewStageClick.bind(this) },
      showCloseIcon: true,
      closeOnEscape: true,
      animationSettings: { effect: 'Zoom' }
    });
    }
    public okNewStageClick(this, filename, model): void {
    //  alert('you clicked OK button');
    // run save file option
    // this.saveBothTemplate(filename, model);
    console.log('SubjectID: ' + model.subject_id);
    this.newSubjectReference(model);
    this.DialogObj.hide();
    }
    
    public cancelNewStageClick(): void {
    // alert('you clicked Cancel button');
    this.DialogObj.hide();
    };
    
    
    
    // Mussing Function
    
    
    // this reports as failes but actually works.
    
    newSubjectReference(model){
      this._demoService.newSubjectReference(model).subscribe(
        data => { // this.new_subject_data = data; // this is the retuned json upon creation.
        this.toastr.success('New Subject Reference Data Entered');
        // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}
    
         // Setup annd the Currents before we redirec the page
         // Needs to be a Function to update the ObserveOnOperator.
         // this.newCTrace_id(this.latest_trace_id);
         // or this.cdata.changeCTrace_id("999");
    
       // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
    
      // this.gfunc.insertLog_UpdateSubjectNewStage(model); 
      if(model.job_status == 'CLOSED'){
        this.gfunc.insertLog_UpdateSubjectNewStageFromClosed(model); 
      }else{
        this.gfunc.insertLog_UpdateSubjectNewStage(model); 
      }
    
    
      // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
        // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
        this.gfunc.globalJobSubjectViewSkipRoute(model.subject_id);
           return true;
    
    
        },
        error => {
        // console.log('Should be form Model' + model);
        // console.error('Error Creating a Trace Project!');
       //  this.toastr.error('Adding Subject Reference Failed :: Please try again!');
       // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
      //  this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
      //  this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
        this.gfunc.globalJobSubjectViewSkipRoute(model.subject_id);
         // console.log(Observable.throw(error));
         // return Observable.throw(error);
        }
    );
    
    
    };
    



}
